import { ModalProps } from '@mui/material'
import { useRef } from 'react'
import Container from '../../components/atoms/Container'
import Heading from '../../components/atoms/Heading'
import DateInput from '../../components/atoms/DateInput'
import Button from '../../components/molecules/Button'
import { StyledDialog, StyledDialogContent } from './styled'

type EditEstimatedPaymentDateProps = {
  open: boolean
  onClose: ModalProps['onClose']
  onSubmit: (date: string) => void
}

const EditEstimatedPaymentDate = (props: EditEstimatedPaymentDateProps) => {
  const dateRef = useRef<HTMLInputElement>(null)

  const handleSubmit = () => {
    const dateValue = dateRef.current?.value
    if (dateValue) {
      props.onSubmit(dateValue)
      if (props.onClose) props.onClose({}, 'backdropClick')
    }
  }

  return (
    <StyledDialog open={props.open} onClose={props.onClose}>
      <StyledDialogContent>
        <Heading type="4" border>
          Establecer Fecha Estimada de Pago
        </Heading>
        <Container>
          <DateInput
            ref={dateRef}
            label="Fecha Estimada de Pago"
          />
          <Button onClick={handleSubmit}>Guardar</Button>
        </Container>
      </StyledDialogContent>
    </StyledDialog>
  )
}

export default EditEstimatedPaymentDate
